export default "__VITE_ASSET__BkcwRI_u__"